import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  prevSelectedRowCell: {
    borderBottom: 'none'
  },
  requestsTable: {
    height: '100%',
    borderCollapse: 'collapse'
  },
  requestsTableHeaderCell: {
    backgroundColor: theme.vars.palette.background.elevation2,
    borderTop: `1px solid ${theme.vars.palette.border.light}`
  },
  requestsTablePagination: {
    position: 'sticky',
    zIndex: 29,
    display: 'relative',
    bottom: 0,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    borderBottom: 0,
    backgroundColor: theme.vars.palette.background.elevation2
  },
  requestsTableWrapper: {
    backgroundColor: theme.vars.palette.background.elevation2,
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    height: '100%',
    overflow: 'auto',
    position: 'relative',
    width: '100%'
  },
  searchBar: {
    backgroundColor: theme.vars.palette.background.elevation1,
    padding: '0.5rem 1rem'
  },
  selectedRow: {
    border: `1px solid ${theme.vars.palette.primary.main}`,
    backgroundColor: theme.vars.palette.transparent.a5,
    td: {
      border: 'none'
    }
  }
}));

export default useStyles;
